import TicketCategoryDetails from "./TicketCategoryDetails";
import TicketCategoryDetailsProvider from "./TicketCategoryDetailsContext";

let Index = () => {

    return (
        <TicketCategoryDetailsProvider>
            <TicketCategoryDetails />
        </TicketCategoryDetailsProvider>
    );
}


export default Index;